import React from "react";
import Form from "react-bootstrap/Form";
import DropdownMain from "../../../../components/dropdown-main/DropdownMain";
import PropTypes from "prop-types";
import "./admin-department-create-panel.scss";
import { dateFormats } from "./admin-department-create-panel-new";

const AdminDepartmentFormLeftColumnNew = ({
  handleChange,
  handleBlur,
  values,
  touched,
  errors,
  setFieldValue,
  setFieldTouched,
}) => {
  return (
    <Form.Row className="left-row">
      <Form.Group className="department-name">
        <Form.Label>
          Department Name <span style={{ color: "red" }}> * </span>
        </Form.Label>
        <Form.Control
          id="Name"
          placeholder="Enter Department Name"
          value={values.Name}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={touched.Name && errors.Name}
        />
        <Form.Control.Feedback
          type="invalid"
          className="inline-error department-error"
        >
          {errors.Name}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group className="department-address">
        <Form.Label>Street Number & Name</Form.Label>
        <Form.Control
          id="Address"
          placeholder="Enter Street Number & Name"
          value={values.Address}
          onChange={handleChange}
        />
      </Form.Group>

      <Form.Row className="location-row">
        <Form.Group className="department-left">
          <Form.Label>City</Form.Label>
          <Form.Control
            id="City"
            placeholder="Enter City"
            value={values.City}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group className="department-right">
          <Form.Label>State/Province/Other</Form.Label>
          <Form.Control
            id="State"
            placeholder="Enter State/Province/Other"
            value={values.State}
            onChange={handleChange}
          />
        </Form.Group>
      </Form.Row>
      <Form.Row className="format-row">
        <Form.Group className="department-left">
          <Form.Label>
            Country <span style={{ color: "red" }}> * </span>
          </Form.Label>
          <Form.Control
            id="Country"
            placeholder="Enter Country"
            value={values.Country}
            onChange={handleChange}
            onBlur={handleBlur}
            isInvalid={touched.Country && errors.Country}
          />
          <Form.Control.Feedback type="invalid" className="inline-error">
            {errors.Country}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className="department-right">
          <Form.Label>Postal Code</Form.Label>
          <Form.Control
            id="Zip"
            placeholder="Enter Postal Code"
            value={values.Zip}
            onChange={handleChange}
          />
        </Form.Group>
      </Form.Row>

      <Form.Row>
        <Form.Group className="department-left">
          <Form.Label>
            Date Format <span style={{ color: "red" }}> * </span>
          </Form.Label>
          <DropdownMain
            values={dateFormats}
            dropdownButtonText={"Select a date format"}
            onSelect={(selectedValue) => {
              setFieldValue("SelectedDateFormat", selectedValue);
            }}
            currentSelected={values?.SelectedDateFormat}
          />
        </Form.Group>

        <Form.Group className="department-right department-url">
          <Form.Label>Website URL</Form.Label>
          <Form.Control
            placeholder="Enter Website URL"
            id="WebsiteURL"
            value={values.WebsiteURL}
            onChange={handleChange}
          />
        </Form.Group>
      </Form.Row>
      <Form.Group className="enable-super-admin-functionality">
        <Form.Label>Super Admin Status</Form.Label>
        <Form.Check
          id="isSuperAdminEnabled"
          checked={values.IsSuperAdmin}
          onChange={(e) => {
            handleChange(e);
            setFieldValue("IsSuperAdmin", true);
          }}
          className="department-active-btn"
          type="checkbox"
          label="Enabled"
        />
        <Form.Check
          id="isSuperAdminInactive"
          checked={!values.IsSuperAdmin}
          onChange={(e) => {
            handleChange(e);
            setFieldValue("IsSuperAdmin", false);
          }}
          className="department-inactive-btn"
          type="checkbox"
          label="Disabled"
        />
      </Form.Group>
    </Form.Row>
  );
};

AdminDepartmentFormLeftColumnNew.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
};
export default AdminDepartmentFormLeftColumnNew;
